// Services
import axios from 'services/axios'

// Endpoint
import { API_PASSWORD_FORGOT, API_PASSWORD_RESET } from 'constants/endpoints'

// Helper
import { encrypt } from 'helpers/hash'

/**
 * Send forgot password email
 *
 * @param {String} email
 */
export const sendForgotPasswordEmail = async (email) => {
  try {
    await axios.post(API_PASSWORD_FORGOT, {
      email,
      data: encrypt({ email }),
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Reset password
 *
 * @param {Object} form
 * @param {String} secret
 */
export const resetPassword = async (form, secret) => {
  try {
    await axios.post(API_PASSWORD_RESET, {
      data: encrypt(form),
      code: secret,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}
